import { matchPath } from 'react-router';
import { useMemo } from 'react';
import { usePageLocation } from '../../../features/page';

export function useCurrentArtistIdOrNull() {
  const location = usePageLocation();

  const match = useMemo(
    () =>
      matchPath<Match>(location.pathname, {
        path: [
          '/artist/:artistId',
          '/team/artist/:artistId',
          '/access/artist/:artistId',
        ],
      }),
    [location.pathname],
  );

  if (!match) {
    return null;
  }

  return match.params.artistId;
}

type Match = {
  artistId: string;
};
